import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Row, Col, Button, Modal, Form, Image } from "react-bootstrap";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as AlbumViewStyles from "../styles/albumView";

//COMPONENTS
import VideoSlot from "./videoSlot";
import VideoViewer from "./videoViewer";

//IMAGES
import albumImage from "../Images/videoAlbumIcon.png";

function VideoAlbumView() {
    const dispatch = useDispatch();
    const params = useParams();

    const addVideoModalDefaults = {
        open: false,
        url: "",
        title: "",
        thumbnail: "",
        loaded: false
    };

    const videoViewerDefaults = {
        open: false,
        videoURL: ""
    };

    const [videoViewer, setVideoViewer] = useState(videoViewerDefaults);

    function handleVideoViewerClose() {
        setVideoViewer(videoViewerDefaults);
    }

    const [addVideoModal, setAddVideoModal] = useState(addVideoModalDefaults);

    function handleCloseAddVideoModal() {
        setAddVideoModal(addVideoModalDefaults);
    }

    const moveModalDefaults = {
        open: false,
        currentAlbum: "",
        videoUUID: "",
        albums: []
    };

    const [moveModal, setMoveModal] = useState(moveModalDefaults);

    function handleCloseMoveModal() {
        setMoveModal(moveModalDefaults);
    }

    const [videos, setVideos] = useState([]);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle(`Photo And Video Gallery - ${params.name.replaceAll("_", " ")}`));
        dispatch(GS_navSettingsActions.UpdateSelected("Media"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Photo Gallery"));

        loadVideos();
    }, []);

    function loadVideos() {
        const data = { uuid: params.id };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/fetchVideos", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setVideos(data.videos);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenAddVideoModal() {
        setAddVideoModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    function handleTextChange(event) {
        const { name, value } = event.target;

        setAddVideoModal((prevState) => {
            return { ...prevState, [name]: value };
        });
    }

    function handleFetchVideo() {
        const data = { url: addVideoModal.url };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/findVideo", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setAddVideoModal((prevState) => {
                        return { ...prevState, title: data.title, thumbnail: data.thumbnail, loaded: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleAddVideo() {
        const data = { albumUUID: params.id, title: addVideoModal.title, videoURL: addVideoModal.url, thumbnailURL: addVideoModal.thumbnail };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/addVideo", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setVideos(data.videos);
                    setAddVideoModal(addVideoModalDefaults);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenViewer(videoURL) {
        setVideoViewer((prevState) => {
            return { ...prevState, videoURL: videoURL, open: true };
        });
    }

    function handleOpenMoveModal(currentAlbum, videoUUID) {
        console.log(currentAlbum, videoUUID);
        const data = { currentAlbum: currentAlbum };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/move_loadVideoAlbums", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setMoveModal((prevState) => {
                        return { ...prevState, currentAlbum, videoUUID, albums: data.albums, open: true };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleMoveModal_AlbumClick(album) {
        const data = { currentAlbum: moveModal.currentAlbum, newAlbum: album, videoUUID: moveModal.videoUUID };
        Axios.post("/pods/CPOD_PHOTOANDVIDEOGALLERY_ADMIN/moveVideoToAnotherAlbum", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setMoveModal(moveModalDefaults);
                    loadVideos();
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <Row>
                <Col>
                    <Button onClick={handleOpenAddVideoModal}>Add Video</Button>
                </Col>
            </Row>
            <Row>
                {videos.map((video, index) => {
                    return (
                        <Col md="auto" style={AlbumViewStyles.columnPadding} key={index}>
                            <VideoSlot
                                videoUUID={video.uuid}
                                name={video.title}
                                thumbnail={video.thumbnailURL}
                                album={params.name}
                                openVideoViewer={handleOpenViewer.bind(this, video.videoURL)}
                                openMoveModal={handleOpenMoveModal}
                                albumLoad={loadVideos}
                            />
                        </Col>
                    );
                })}
            </Row>
            {/* MODALS */}
            <Modal show={addVideoModal.open} onHide={handleCloseAddVideoModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Video</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Video URL:</Form.Label>
                        <Form.Control type="text" name={"url"} value={addVideoModal.url} onChange={handleTextChange} />
                    </Form.Group>
                    <br />
                    <Row>
                        <Col>
                            <strong>{!addVideoModal.loaded ? "Insert an URL and click Fetch" : addVideoModal.title}</strong>
                        </Col>
                        <Col style={AlbumViewStyles.video_columnCenter}>
                            {addVideoModal.loaded && <Image src={addVideoModal.thumbnail} style={AlbumViewStyles.videoThumbnail} />}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {addVideoModal.loaded ? <Button onClick={handleAddVideo}>Add</Button> : <Button onClick={handleFetchVideo}>Fetch</Button>}
                    <Button onClick={handleCloseAddVideoModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal size="lg" show={moveModal.open} onHide={handleCloseMoveModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Move</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {moveModal.albums.length == 0 ? (
                        <div style={AlbumViewStyles.move_noAblums}>There are no other photo albums to move it to</div>
                    ) : (
                        <div>
                            Select album to move the image to: <br /> <br />
                            <Row>
                                {moveModal.albums.map((album, index) => {
                                    return (
                                        <Col
                                            sm={4}
                                            key={index}
                                            style={AlbumViewStyles.albumBody}
                                            onClick={handleMoveModal_AlbumClick.bind(this, album)}
                                        >
                                            <div style={AlbumViewStyles.cardPicture}>
                                                <Image src={albumImage} style={AlbumViewStyles.albumImage} />
                                            </div>
                                            <div style={AlbumViewStyles.cardText}>{album.albumName.replace("_", " ")}</div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseMoveModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <VideoViewer open={videoViewer.open} handleClose={handleVideoViewerClose} videoURL={videoViewer.videoURL} />
        </div>
    );
}

export default VideoAlbumView;
